import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitOrigenes } from './hooks'
import { OrigenesTable } from './OrigenesTable'
import { OrigenesForm } from './OrigenesForm'

export const OrigenesCredito = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitOrigenes({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

        // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // const { fetchAllClients } = FetchData
    // const { loadingFetchAllClients } = fetchAllClients
    // ------------------------------------------------ Actions
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['252_ORIGENES_DE_CREDITO']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Origenes de Crédito</div>
                                            <div className="border-bottom border-dark"></div>
                                            {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                            <div className="d-flex justify-content-end pt-4">
                                                <Button
                                                    style={{background: "#4b4b4c"}}
                                                    variant="contained"
                                                    type="button"
                                                    onClick={() => handleClickShowForm(true)}
                                                >
                                                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                                </Button>
                                            </div>

                                            <div className="pt-4"></div>
                                            <OrigenesTable useFetchInit={useFetchInit} />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            <OrigenesForm useFetchInit={useFetchInit} />
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )
}
